import { render } from "./ServiceProvidersTab.vue?vue&type=template&id=7f5a521a&scoped=true"
import script from "./ServiceProvidersTab.vue?vue&type=script&lang=js"
export * from "./ServiceProvidersTab.vue?vue&type=script&lang=js"

import "./ServiceProvidersTab.vue?vue&type=style&index=0&id=7f5a521a&scoped=true&lang=less"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.18.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5a521a"]])

export default __exports__